import { render } from "./FormSubheader.vue?vue&type=template&id=2baa0516"
import script from "./FormSubheader.vue?vue&type=script&lang=js"
export * from "./FormSubheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__